var map = {
	"./BubbleBackground.png": [
		2728,
		2728
	],
	"./Section (1).png": [
		6717,
		6717
	],
	"./Section (1).webp": [
		3915,
		3915
	],
	"./Section (2).png": [
		9925,
		168
	],
	"./Section.png": [
		4688,
		4688
	],
	"./Section.webp": [
		8649,
		8649
	],
	"./aboutsection.webp": [
		4348
	],
	"./aboutusimage.png": [
		2583
	],
	"./articwhite.jpg": [
		3601,
		3601
	],
	"./articwhite1.png": [
		6707,
		6707
	],
	"./atmrusticapp1.jpeg": [
		4470,
		4470
	],
	"./atmrusticapp2.jpeg": [
		6071,
		6071
	],
	"./autumnrustic.webp": [
		9847
	],
	"./background.jpeg": [
		1667,
		1667
	],
	"./black.webp": [
		6854
	],
	"./blackapplication1.png": [
		6624,
		6624
	],
	"./blackapplication2.jpeg": [
		2551,
		2551
	],
	"./choose1.webp": [
		7612
	],
	"./company.png": [
		6301
	],
	"./company.webp": [
		1573
	],
	"./contactus.jpg": [
		8640
	],
	"./copper.png": [
		8366,
		1407
	],
	"./copperapp1.jpg": [
		8906,
		8906
	],
	"./copperapp2.jpeg": [
		9638,
		9638
	],
	"./cosmoswhite.png": [
		377,
		377
	],
	"./cosmoswhite1.png": [
		9254,
		9254
	],
	"./cosmoswhiteapp1.jpeg": [
		4004,
		4004
	],
	"./customersatisfaction1.png": [
		6582,
		6582
	],
	"./cutting-machine.webp": [
		6853
	],
	"./employeetrain1.jpeg": [
		6684,
		6684
	],
	"./factory1.jpeg": [
		5352
	],
	"./greengold.png": [
		5915,
		5915
	],
	"./hero_bg.svg fill.png": [
		6577,
		6577
	],
	"./indianatmapp1.jpeg": [
		4700,
		4700
	],
	"./indianatmapp2.jpeg": [
		3094,
		3094
	],
	"./indianautumn.webp": [
		1723
	],
	"./monsoonblack.png": [
		5730,
		5730
	],
	"./monsoonblkapp1.png": [
		185,
		185
	],
	"./monsoonblkapp2.jpeg": [
		466,
		466
	],
	"./oceanblack.webp": [
		3001
	],
	"./oceanblkapp1.jpeg": [
		7866,
		7866
	],
	"./oceanblkapp2.jpg": [
		1624,
		1624
	],
	"./oceanblkapp3.jpeg": [
		9509,
		9509
	],
	"./productionprocess1.jpeg": [
		399,
		399
	],
	"./quality.png": [
		4828,
		4828
	],
	"./qualitycontrol1.jpeg": [
		5956,
		5956
	],
	"./rainbow.jpg": [
		4073,
		4073
	],
	"./rainforest.png": [
		7344,
		7344
	],
	"./rawmaterial1.png": [
		5149,
		5149
	],
	"./rforestgreenapp1.jpeg": [
		7500,
		7500
	],
	"./silvergalaxy.png": [
		7706,
		7706
	],
	"./silverglxyapp2.jpeg": [
		3714,
		3714
	],
	"./silvergrey.jpg": [
		2653,
		2653
	],
	"./silvergreyapp1.webp": [
		8855,
		8855
	],
	"./silviawhite.webp": [
		9121
	],
	"./silviawhiteapp1.jpeg": [
		4104,
		4104
	],
	"./teakwood.jpg": [
		9105,
		9105
	],
	"./teakwoodapp1.webp": [
		8767,
		8767
	],
	"./teakwoodapp2.webp": [
		5493,
		5493
	],
	"./translucent.png": [
		6459,
		6459
	],
	"./translucent1.png": [
		4009,
		4009
	],
	"./translucentapp1.jpeg": [
		8749,
		8749
	],
	"./translucentapp2.jpeg": [
		8917,
		8917
	],
	"./veneerheaderimg.webp": [
		9749
	],
	"./vkaystone.png": [
		7902,
		7902
	],
	"./vkaytag.jpeg": [
		9380
	],
	"./world-map-background.png": [
		1636,
		1636
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1028;
module.exports = webpackAsyncContext;